// components
import getIcon from "utils/getIcon";
import { Button, Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import Spinner from "components/atoms/Spinner/Spinner";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";
import StepContainer from "components/molecules/StepContainer/StepContainer";
import ReimbursementVerificationReviewDetails from "components/organisms/ReimbursementVerificationReviewDetails/ReimbursementVerificationReviewDetails";

// constants
import { PageTitles, ReimbursementRejectClaim as Constants } from "constants/global";

// hook
import { useReimbursementVerificationRejectClaim } from "containers/ReimbursementVerificationRejectClaim/useReimbursementVerificationRejectClaim";

// styles
import styles from "containers/ReimbursementVerificationRejectClaim/reimbursementVerificationRejectClaim.module.css";

const ReimbursementVerificationRejectClaim = () => {
	const { claimDetails, documents, fieldDetails, claimsLoading, fieldErrs, enableApproveRejectButtons, validateFields, handleChangeDetails, handleRejectClaim, goBack } =
		useReimbursementVerificationRejectClaim();

	const reimAmountCls = fieldDetails?.reim_amount ? styles?.filled : "";
	const reimRejectReasonClass = fieldDetails?.rejection_reason ? styles?.filled : "";

	return (
		<div className="relative">
			{claimsLoading && <Spinner type="transparent" />}
			<div className={styles?.bg_curve}>{getIcon({ icon: "landingPageBackground" })}</div>
			<div className={styles?.bg_frame}>{getIcon({ icon: "businessDecisions" })}</div>
			<Head>{PageTitles.REIMBURSEMENT_VERIFICATION_REJECT}</Head>
			<PageTitle showBackIcon={true} goBack={goBack} title={Constants.ROLE_HEADER} subTitle={Constants.ROLE_SUB_HEADER} />

			<div className={styles?.wrapper}>
				<ReimbursementVerificationReviewDetails claimDetails={claimDetails} documents={documents} />

				<div className={styles?.reject_info_wrapper}>
					<StepContainer step={1} subHeader={Constants.STEP1_HEADER} />
					<Form.Item
						name={Constants.FIELD_REIM_AMOUNT}
						extra={
							fieldErrs?.reim_amount && (
								<ErrorMessage message={`${fieldDetails?.reim_amount ? Constants.INVALID_AMOUNT_ERR : Constants.REQUIRED_ERR}`} classes="text-red-500"></ErrorMessage>
							)
						}
					>
						<Input
							type={"number"}
							id={Constants.FIELD_REIM_AMOUNT}
							onBlur={() => validateFields(Constants.FIELD_REIM_AMOUNT)}
							value={fieldDetails?.reim_amount}
							data-testid={Constants.FIELD_REIM_AMOUNT}
							onChange={(e) => handleChangeDetails(e.target.id, e.target.value)}
							placeholder={Constants.REIM_AMOUNT_PLACEHOLDER}
							className={`${styles?.step_input} ${fieldErrs?.reim_amount ? styles?.err : reimAmountCls}`}
						/>
					</Form.Item>
					<StepContainer step={2} subHeader={Constants.STEP2_HEADER} />
					<div className="w-full flex flex-col md:flex-row">
						<Form.Item
							style={{ width: "inherit" }}
							name={Constants.FIELD_REJECTION_REASON}
							extra={
								fieldErrs?.rejection_reason && (
									<ErrorMessage message={`${fieldDetails?.rejection_reason ? Constants.INVALID_REJECTION_ERR : Constants.REQUIRED_ERR}`} classes="text-red-500"></ErrorMessage>
								)
							}
						>
							<Input.TextArea
								id={Constants.FIELD_REJECTION_REASON}
								value={fieldDetails?.rejection_reason}
								onChange={(e) => handleChangeDetails(e.target.id, e.target.value)}
								data-testid={Constants.FIELD_REJECTION_REASON}
								placeholder={Constants.REJECTION_REASON_PLACEHOLDER}
								className={`${styles?.step_input_textarea} ${fieldErrs?.rejection_reason ? styles?.err : reimRejectReasonClass}`}
								onBlur={() => validateFields(Constants.FIELD_REJECTION_REASON)}
							/>
						</Form.Item>
					</div>
					<div className={styles?.action_buttons_wrapper}>
						<Button type="primary" danger disabled={!enableApproveRejectButtons} className={styles?.reject_button} onClick={handleRejectClaim}>
							{Constants?.REJECT_BTN_LABEL}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReimbursementVerificationRejectClaim;
